// JornadaAvisosGate.jsx
//
// #1887 · qué se le muestra al médico cuando un punto de IA responde 403 con uno de los codes nuevos (spec
// `.claude/specs/jornada-suelta/`, T25 y T26, R62). `get-client.js` ya emite `smartdx:acceso-bloqueado` con el `code` de cualquier 403
// de billing; ESTE componente es el único que reacciona a `sin_jornadas`, `requiere_boton` y `ventana_terminada`:
//   · `sin_jornadas`              -> pantalla `jornadas-agotadas` (comprar una suelta, subir de plan o seguir sin generar)
//   · `requiere_boton` / `ventana_terminada` -> la confirmación de la jornada con la hora a la vista (`JornadaConfirmarDialog`)
// A PROPÓSITO no están en `SuscripcionGate.CODES_QUE_BLOQUEAN`: ninguno tapa la app (leer, copiar, editar y guardar siguen, R52);
// si lo estuvieran, un corte de IA bloquearía todo el turno. Y cada pieza que recibe el 403 (generar, dictado, escaneo)
// NO pinta su error técnico (`esCorteDeJornada`): el aviso es este, y lo escrito no se pierde.
// Una ráfaga (el lote hace una llamada por cama) abre UN aviso, no veinte.
// Cubre R35, R62 — .claude/specs/jornada-suelta/
import { useEffect, useRef, useState } from "react";
import JornadasAgotadas from "../jornadas/JornadasAgotadas";
import { abrirConfirmacionJornada, esCodeDeCorte, opcionesDe } from "../../helpers/suelta-api";
import { estadoActualDeJornada, recargarJornada } from "../../hooks/useJornadaEstado";

const RAFAGA_MS = 1500;

const JornadaAvisosGate = () => {
  const [agotadas, setAgotadas] = useState(false);
  const ultimo = useRef(0);

  useEffect(() => {
    const alBloqueo = (event) => {
      const code = event?.detail?.code;
      if (!esCodeDeCorte(code)) return;
      const t = Date.now();
      if (t - ultimo.current < RAFAGA_MS) return;
      ultimo.current = t;
      if (code === "sin_jornadas") {
        setAgotadas(true);
        return;
      }
      // El estado puede estar viejo (no había opciones al cargar la página): se relee y recién ahí se abre la confirmación
      // con la hora que de verdad correspondería. Si ya no hay nada que activar, lo que corresponde es la pantalla de compra.
      recargarJornada().then(() => {
        if (opcionesDe(estadoActualDeJornada().jornada).length) abrirConfirmacionJornada();
        else setAgotadas(true);
      });
    };
    window.addEventListener("smartdx:acceso-bloqueado", alBloqueo);
    return () => window.removeEventListener("smartdx:acceso-bloqueado", alBloqueo);
  }, []);

  return <JornadasAgotadas abierta={agotadas} onCerrar={() => setAgotadas(false)} />;
};

export default JornadaAvisosGate;
